import { Select } from "antd";
import { getSupplierTypes } from "api/coreapi/suppliers";
import { useEffect, useState } from "react";
import { EnumTypeModel } from "shared/models/enumTypeModel";

interface SupplierTypesSelectProps {
    value?: number;
    onChange?: (value?: number) => void;
}

const SupplierTypesSelect: React.FC<SupplierTypesSelectProps> = (props) => {
    const {
        value,
        onChange        
    } = props;
    
    var [types, setTypes] = useState<EnumTypeModel[]>();
    const triggerChange = (changedValue?: number) => {
        onChange?.(changedValue);
      };

      const onSelectedItemChange = (newType: number) => {
        triggerChange(newType);
      };

    useEffect(() => {

        const getInfo = async () => {
            try {
                const res = await getSupplierTypes();
                setTypes(res.result);
            } catch (error: any) {
            }
        };

        getInfo();
    }, []);


    return (
        <Select
            style={{ width: 220 }}
            defaultValue={value}
            onChange={onSelectedItemChange}
            options={types?.map((item) => ({
                value: item.id,
                label: item.displayName ?? item.name,
            }))}
        />

    );
}

export default SupplierTypesSelect;